import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import authInstance from "src/api/apiConfig";
import { getAllEmisByEmiStatus } from "src/redux/actions/emiAction";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
} from "src/services/const";
import { formatDate } from "src/services/helpers";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";

const PendingEmiDetails = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { emiStatusData } = useSelector((state) => state?.emiReducer);
  const SchemaName = sessionStorage.getItem("schemaName");
  const [minEndDate, setMinEndDate] = useState("");
  const [status, setStatus] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [selectedEmiStatus, setSelectedEmiStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [printState, setPrintState] = useState(false);
  const [balanceData, setBalanceData] = useState();
  const componentPDF = useRef();
  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  const objData = {
    schemaName: SchemaName,
    emiStatus: selectedEmiStatus,
    startDate: startDate,
    enddate: endDate,
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const handleSearch = () => {
    if (selectedEmiStatus === "balance") {
      handleAllCustomerEmis();
    } else {
      setStatus(true);
      setShowTable(true);
    }
  };

  const handleAllCustomerEmis = async () => {
    const payload = {
      schemaName: SchemaName,
    };
    try {
      const response = await authInstance.post(
        "/newapigetCustomerdata",
        payload
      );

      if (response?.status === 200) {
        setBalanceData(response?.data?.data?.customers || []);
        setStatus(true);
        setShowTable(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (status === true) {
      dispatch(getAllEmisByEmiStatus(objData));
      setStatus(false);
    }
  }, [status, showTable]);

  const handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStartDate(selectedStartDate);
    setMinEndDate(selectedStartDate);
    if (endDate < selectedStartDate) {
      setEndDate("");
    }
  };

  const filterByGroupName = () => {
    let filteredRows = emiStatusData?.data || [];
    if (customerName) {
      filteredRows = filteredRows?.filter(
        (item) =>
          String(
            item?.customer?.loanAccountNumber.toString().toLowerCase()
          ).includes(String(customerName)) ||
          String(
            item?.customer?.branch.branchName.toString().toLowerCase()
          ).includes(String(customerName)) ||
          String(item?.customer?.firstName.toString().toLowerCase()).includes(
            String(customerName)
          ) ||
          String(item?.customer?.phoneNumber.toString().toLowerCase()).includes(
            String(customerName)
          )
      );
    }
    return filteredRows;
  };

  const filteredRows = filterByGroupName();
  const download_btn = () => {
    setPrintState(true);
  };

  const groupedByLoanAccountNumber = filteredRows?.reduce((acc, company) => {
    const loanAccountNumber = company?.customer?.loanAccountNumber || "-";
    if (!acc[loanAccountNumber]) {
      acc[loanAccountNumber] = [];
    }
    acc[loanAccountNumber]?.push(company);
    return acc;
  }, {});

  return (
    <div className="content">
      <CCard className="custom-card">
        <CCardHeader className="custom-card-header">
          <h5>All Pending Emis Details</h5>
        </CCardHeader>
        <CCardBody>
          <div>
            <CRow className="mb-2">
              <CCol xs={6}>
                <CFormLabel htmlFor="start_date" className="custom-form-label">
                  Start Date
                  <span className="red-star">{` `}*</span>
                </CFormLabel>
                <CFormInput
                  type="date"
                  size="sm"
                  placeholder="Start Date"
                  aria-label="sm input example"
                  onChange={handleStartDateChange}
                  value={startDate}
                  required
                  className="custom-form-input"
                />
              </CCol>
              <CCol xs={6}>
                <CFormLabel htmlFor="address" className="custom-form-label">
                  End Date
                  <span className="red-star">{` `}*</span>
                </CFormLabel>
                <CFormInput
                  type="date"
                  size="sm"
                  placeholder="End Date"
                  aria-label="End Date"
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                  min={minEndDate}
                  required
                  className="custom-form-input"
                />
              </CCol>
            </CRow>
            <CRow className="mb-2">
              <CCol xs={6}>
                <CFormLabel htmlFor="emi-type" className="custom-form-label">
                  Select EMI Type <span className="red-star">*</span>
                </CFormLabel>
                <CFormSelect
                  value={selectedEmiStatus}
                  onChange={(e) => setSelectedEmiStatus(e.target.value)}
                  required
                  className="custom-form-input"
                >
                  <option value="">Select EMI Type</option>
                  <option value="paid">Paid</option>
                  <option value="pending">Pending</option>
                  <option value="extended_date">Extended Date</option>
                  <option value="balance">Balance</option>
                </CFormSelect>
              </CCol>
              <CCol xs={6} className="d-flex align-items-end">
                <CButton onClick={handleSearch} className="custom-submit-btn">
                  Search
                </CButton>
              </CCol>
            </CRow>
          </div>
          {showTable && (
            <div className="table-container">
              <div className="searchinput mb-2">
                <div className="row">
                  <div className="col-xs-12 col-md-4 col-lg-5">
                    <label
                      htmlFor="customer-name"
                      className="custom-form-label"
                    >
                      Loan Account Number
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm custom-form-input"
                      placeholder="Loan Account Number"
                      aria-label="Loan Account Number"
                      onChange={(e) => setCustomerName(e.target.value)}
                      value={customerName}
                      style={{ marginTop: "8px" }}
                    />
                  </div>
                  <div
                    className="col-xs-12 col-md-4 col-lg-2"
                    style={{ marginTop: "30px" }}
                  >
                    <button
                      className="custom-submit-btn"
                      onClick={download_btn}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
              <div
                ref={printState ? componentPDF : null}
                style={{ padding: printState ? "20px" : "0px" }}
              >
                {printState && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      background:
                        "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                      padding: "20px",
                    }}
                  >
                    <img
                      src={COMPANY_AddLogo}
                      alt="Logo"
                      width="50px"
                      height="50px"
                    />
                    <p style={{ color: "#FFF" }}>Emi Details</p>
                    <div style={{ textAlign: "start" }}>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "#FFF",
                          fontSize: "20px",
                        }}
                      >
                        {COMPANY_NAME}
                      </p>
                      <p style={{ color: "#FFF" }}>{`(${COMPANY_Address})`}</p>
                    </div>
                  </div>
                )}
                <table className="custom-table">
                  {selectedEmiStatus !== "balance" ? (
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Loan Account No.</th>
                        <th>Customer Name</th>
                        <th>Phone Number</th>
                        <th>Branch Code</th>
                        <th>EMI Amount</th>
                        <th>Penalty</th>
                        <th>
                          {selectedEmiStatus === "paid"
                            ? "Paid Date"
                            : "Due Date"}
                        </th>
                        <th>Extended Date</th>
                        <th>Emi Details</th>
                        {selectedEmiStatus === "balance" && (
                          <th>Total Balance</th>
                        )}
                      </tr>
                    </thead>
                  ) : (
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Loan Account No.</th>
                        <th>Customer Name</th>
                        <th>Phone Number</th>
                        <th>Branch Code</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                  )}

                  {selectedEmiStatus === "balance" ? (
                    <tbody>
                      {balanceData?.map((customer, groupIndex) => {
                        const totalBalance = customer?.disbursements?.length
                          ? customer.disbursements.reduce(
                            (acc, disbursement) => acc + (disbursement.balance || 0),
                            0
                          )
                          : "--";

                        // Only render rows where totalBalance > 0
                        // Hide if no disbursements or totalBalance is zero/negative
                        if (
                          (typeof totalBalance === "number" && totalBalance <= 0) ||
                          totalBalance === "--"
                        ) return null;

                        return (
                          <tr key={groupIndex}>
                            <td>{indexOfFirstRow + groupIndex + 1}</td>
                            <td>{customer?.Customers?.loanAccountNumber || "--"}</td>
                            <td>{customer?.Customers?.firstName || "--"}</td>
                            <td>{customer?.Customers?.phoneNumber || "--"}</td>
                            <td>{customer?.branch?.branchName || "--"}</td>
                            {selectedEmiStatus === "balance" && <td>{totalBalance}</td>}
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tbody>
                      {Object.keys(groupedByLoanAccountNumber)?.map(
                        (loanAccountNumber, groupIndex) => {
                          const customerIdToMatch =
                            groupedByLoanAccountNumber[loanAccountNumber][0]
                              ?.customer?.id;
                          const { totalPaid, totalPending } =
                            groupedByLoanAccountNumber[
                              loanAccountNumber
                            ]?.reduce(
                              (acc, company) => {
                                const emiAmount =
                                  Number(company.emiAmount) || 0;
                                if (
                                  company?.customer?.id === customerIdToMatch
                                ) {
                                  if (company.emiStatus === "paid") {
                                    acc.totalPaid += emiAmount;
                                  } else if (company.emiStatus === "pending") {
                                    acc.totalPending += emiAmount;
                                  }
                                }
                                return acc;
                              },
                              { totalPaid: 0, totalPending: 0 }
                            );

                          return groupedByLoanAccountNumber[
                            loanAccountNumber
                          ]?.map((company, index) => (
                            <tr key={`${groupIndex}-${index}`}>
                              <td>
                                {indexOfFirstRow + groupIndex + index + 1}
                              </td>
                              <td>
                                {company?.customer?.loanAccountNumber
                                  ? company?.customer?.loanAccountNumber
                                  : "--"}
                              </td>
                              <td>{company?.customer?.firstName}</td>
                              <td>
                                {company?.customer?.phoneNumber
                                  ? company?.customer?.phoneNumber
                                  : "--"}
                              </td>
                              <td>
                                {company?.customer?.branch.branchName
                                  ? company?.customer?.branch.branchName
                                  : "--"}
                              </td>
                              <td>
                                {company?.emiAmount ? company?.emiAmount : "--"}
                              </td>
                              <td>
                                {company?.penalty ? company?.penalty : "--"}
                              </td>
                              <td>
                                {company?.dueDate
                                  ? formatDate(company?.dueDate)
                                  : "--"}
                              </td>
                              <td>
                                {company?.extended_date
                                  ? formatDate(company?.extended_date)
                                  : "--"}
                              </td>
                              <td className="col-md-2">
                                <button
                                  style={{
                                    gap: "2px",
                                    border: "none",
                                    backgroundColor: "#007bff",
                                    borderRadius: "7px",
                                    color: "white",
                                    margin: "2px 8px",
                                    fontSize: "14px",
                                    width: "80px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                  className="view-button btn_view margin_auto"
                                  onClick={() =>
                                    navigate(
                                      `/emi-details?account_number=${company.customer.loanAccountNumber}`
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    role="button"
                                    icon={faFile}
                                    size="1x"
                                    className="viewIcon "
                                  />
                                  Emi Record
                                </button>
                              </td>
                              {/* <td>
                                {company?.emiAmount
                                  ? `${
                                      Number(company?.emiAmount) +
                                      company?.annualInterestRate +
                                      company?.interestAmount +
                                      Number(company?.penalty).toFixed(2)
                                    }`
                                  : "--"}
                              </td> */}
                            </tr>
                          ));
                        }
                      )}
                    </tbody>
                  )}
                </table>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div style={{ fontSize: "16px", fontWeight: "600" }}>
                  Showing {emiStatusData?.data?.length} entries
                </div>
              </div>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default PendingEmiDetails;
